import RecruitNavigation from '../components/RecruitNavigation';
import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { Building2, Briefcase } from 'lucide-react';
import { LanguageContext } from '../contexts/LanguageContext';
import { getLanguageConfig } from '../config/languages';
import { getHeadingFontClass } from '../utils/fontUtils';
import Button from '../components/ui/Button';

export default function CompanyRecruit() {
  const intl = useIntl();
  const { locale } = useContext(LanguageContext);
  const currentLanguageConfig = getLanguageConfig(locale);
  const showRecruit = currentLanguageConfig.showRecruit;

  // 会社情報の配列
  const companyDetails = [
    { labelId: 'company.name', valueId: 'company.name.value' },
    { labelId: 'company.location', valueId: 'company.location.value' },
    { labelId: 'company.established', valueId: 'company.established.value' },
    { labelId: 'company.capital', valueId: 'company.capital.value' },
  ];

  // 代表者情報の配列
  const representatives = [
    {
      titleId: 'company.representative.ceo',
      nameId: 'company.representative.ceo.value',
    },
  ];

  return (
    <div className="py-16 md:py-24 relative overflow-hidden bg-secondary">
      <div className="container relative z-10">
        <div
          className={`grid grid-cols-1 ${showRecruit ? 'lg:grid-cols-[3fr_2fr]' : ''} gap-8`}
        >
          {/* Company セクション */}
          <div
            id="company"
            className="bg-card rounded-2xl p-8 shadow-card border border-border animate-slideInLeft"
            style={{ animationDelay: '0.3s' }}
          >
            {/* ヘッダー */}
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary/80 to-primary flex items-center justify-center">
                <Building2 className="w-6 h-6 text-white" />
              </div>
              <div>
                <h2 className="text-2xl lg:text-3xl font-bold gradient-text font-heading">
                  {intl.formatMessage({ id: 'company.title' })}
                </h2>
                <p className="text-muted-foreground text-sm font-body">
                  {intl.formatMessage({ id: 'company.subtitle' })}
                </p>
              </div>
            </div>

            {/* 会社情報リスト */}
            <dl className="space-y-4">
              {companyDetails.map((detail, index) => (
                <div
                  key={index}
                  className="pb-3 border-b border-border last:border-b-0 last:pb-0"
                >
                  <dt
                    className={`text-sm font-semibold text-muted-foreground mb-1 ${getHeadingFontClass(locale)}`}
                  >
                    {intl.formatMessage({ id: detail.labelId })}
                  </dt>
                  <dd className="text-base text-card-foreground font-body">
                    {intl.formatMessage({ id: detail.valueId })}
                  </dd>
                </div>
              ))}
              {/* 代表者情報 */}
              <div className="pb-3 border-b border-border last:border-b-0 last:pb-0">
                <dt
                  className={`text-sm font-semibold text-muted-foreground mb-2 ${getHeadingFontClass(locale)}`}
                >
                  {intl.formatMessage({ id: 'company.representative' })}
                </dt>
                <dd className="flex flex-col gap-1">
                  {representatives.map((rep, repIndex) => (
                    <span
                      key={repIndex}
                      className="text-base text-card-foreground font-body"
                    >
                      {intl.formatMessage({ id: rep.titleId })}{' '}
                      {intl.formatMessage({ id: rep.nameId })}
                    </span>
                  ))}
                </dd>
              </div>
            </dl>
          </div>

          {/* Recruit セクション */}
          {showRecruit && (
            <div
              id="recruit"
              className="bg-card rounded-2xl p-8 shadow-card border border-border flex flex-col animate-slideInRight"
              style={{ animationDelay: '0.5s' }}
            >
              {/* ヘッダー */}
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary/80 to-primary flex items-center justify-center">
                  <Briefcase className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h2 className="text-2xl lg:text-3xl font-bold gradient-text font-heading">
                    {intl.formatMessage({ id: 'recruit.title' })}
                  </h2>
                  <p className="text-muted-foreground text-sm font-body">
                    {intl.formatMessage({ id: 'recruit.subtitle' })}
                  </p>
                </div>
              </div>

              {/* 説明文 */}
              <p className="text-base lg:text-lg text-muted-foreground font-body leading-[2.2] flex-grow">
                {locale === 'ja'
                  ? '日本トレカセンターでは、プロダクトづくりと事業の成長を支える仲間を募集しています。'
                  : intl.formatMessage({ id: 'recruit.description' })}
              </p>

              {locale === 'ja' && <RecruitNavigation />}

              {/* ボタン */}
              <div className={locale === 'ja' ? 'hidden' : 'mt-8'}>
                <Button
                  href="https://www.wantedly.com/companies/company_5841931"
                  className="px-8 py-3 font-body w-full sm:w-auto min-w-[200px] text-center"
                >
                  {intl.formatMessage({ id: 'recruit.button' })}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
